import { z } from "zod";

export const httpMethodFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    method: z.string(),
    format: z.string(),
    timeout: z.number(),
    endpoint: z.string(),
    query: z.array(z.object({ type: z.string(), key: z.string(), value: z.string() })),
    header: z.array(z.object({ key: z.string(), value: z.string() })),
    body: z.array(z.object({ type: z.string(), key: z.string(), value: z.string() })),
});

export type HttpMethodFormData = z.infer<typeof httpMethodFormSchema>;
